<script setup>
// import { ref } from 'vue';
// import SawitBuahTable from "./Tables/SawitBuahTable.vue";
// import ProductTable from "./Tables/ProductTable.vue";
// import ArgonInput from "@/components/ArgonInput.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
import CustomerListModal from "./components/CustomerListModal.vue";
</script>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-md-6">
            <div class="card">
                <div class="card-header pb-0">
                    <h6>Products</h6>
                </div>
                <div class="container-fluid">
                    <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Item</label>
                            <!-- <select class="form-control" v-model="model.stock.id"> 
                                <optgroup v-for="(items, category) in groupedStockItems" :label="category" :key="category" > 
                                    <option v-for="(itemObj) in items" :key="itemObj.id" :value="itemObj.id" > 
                                        {{ itemObj.item }} - {{ itemObj.supplier }}
                                    </option> 
                                </optgroup> 
                            </select> -->
                            <select class="form-control" v-model="product.productsid">
                                <optgroup
                                    v-for="(items, groupLabel) in groupedProduct"
                                    :key="groupLabel"
                                    :label="groupLabel"
                                >
                                    <option
                                    v-for="item in items"
                                    :key="item.productid"
                                    :value="item.productid"
                                    >
                                    {{ item.name }}
                                    </option>
                                </optgroup>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label text-danger">Content</label>
                            <input type="text" id="input_dateto" class="form-control" v-model="product.content">
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">size</label>
                            <input type="text" id="input_size" class="form-control" v-model="product.size">
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Unit Price (RM)</label>
                            <input type="number" id="input_price" class="form-control" v-model="product.price">
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Quantity</label>
                            <input class="form-control" v-model="product.quantity" id="input_quantity" type="number" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Sub Total (RM)</label>
                            <input type="number" id="input_subtotal" class="form-control" :value="product.price * product.quantity" disabled>
                        </div>
                    </div>
                    <div class="row">
                        <!-- <div class="col-md-10">
                            <button class="btn btn-info " @click="addStock" style="float: right;" id="btn_camera">Open Camera</button>
                        </div> -->
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="addCheckOut" style="float: right;" id="btn_add">Add</button>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="mt-4 card">
                <div class="card-header pb-0">
                    <h6>Other Cost</h6>
                </div>
                <div class="container-fluid">
                    <div class="row " style="padding-bottom: 35px;">
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label">Transport (RM)</label>
                            <input class="form-control" v-model="customer.transport" id="input_transport" type="number" />
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label">Duit Turun Pokok (RM)</label>
                            <input type="number" id="input_dtp" class="form-control" v-model="customer.dtp">
                        </div>
                    </div>
                    <!-- <div class="row mt-3">
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="addOtherCost" style="float: right;" id="btn_add_other_cost">Add</button>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card" style="padding-bottom: 30px;">
                <div class="card-header pb-0">
                    <div class="row">
                        <div class="col-md-3">
                            <h6>Customer Info</h6>
                        </div>
                        <div class="col-md-3">
                            <h6><input id="chk" type="checkbox" v-model="customer.saveCustomer" /> Save Customer</h6>
                        </div>
                        <div class="col-md-6 d-flex justify-content-end"> 
                            <button class="btn btn-info" @click="showPopupCustomerLisModal" >Customer List</button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row ">
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label">Company Profile</label>
                            <select class="form-control" v-model="customer.companyprofile">
                                <option value="1">Ang Chin Joo Nusery</option>
                                <option value="2">Ang Chin Joo Rubber & Palm Oil</option>
                                <option value="99">Others</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label">Invoice No</label>
                            <input class="form-control" v-model="customer.invoiceno" id="input_invoice" type="text" placeholder="Invoice No" />
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label">Name</label>
                            <input class="form-control" v-model="customer.name" id="input_name" type="text" placeholder="ANG CHIN JOO" />
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label">Company</label>
                            <input class="form-control" v-model="customer.company" id="input_weight" type="text" placeholder="ANG CHIN JOO NUSERY SDN BHD" />
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label">Contact</label>
                            <input class="form-control" v-model="customer.contact" type="text" placeholder="0168815145" />
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label">IC</label>
                            <input class="form-control" v-model="customer.ic" type="text" placeholder="ic..." />
                        </div>
                        <div class="col-md-12">
                            <label for="example-text-input" class="form-control-label">Address</label>
                            <input class="form-control" v-model="customer.address" type="text" placeholder="1 Tingkat,2 Tingkat" />
                        </div>
                        <!-- <div class="col-md-4">
                            <div class="mt-3 d-flex">
                                <h6 class="mb-0">Delivery Info</h6>
                                <div class="form-check form-switch ps-0 ms-auto my-auto">
                                    <input
                                    class="mt-1 form-check-input"
                                    :class="' ms-auto'"
                                    type="checkbox"
                                    v-model="ischeckDO"
                                    />
                                </div>
                            </div>
                        </div> -->
                        <div class="col-md-4">
                            <label for="example-text-input" class="form-control-label">Order Status</label>
                            <select class="form-control" v-model="customer.orderstatus">
                                <option value="0">Pending</option>
                                <option value="1">Half Payment</option>
                                <option value="2">Completed</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label for="example-text-input" class="form-control-label">Issue Date</label>
                            <input class="form-control" v-model="customer.issuedate" id="input_date" type="date" />
                        </div>
                        <div class="col-md-4" v-show="customer.orderstatus != 0">
                            <label for="example-text-input" class="form-control-label">Payment Date</label>
                            <input class="form-control" v-model="customer.paymentdate" id="input_date" type="date" />
                        </div>
                        <!-- <div class="col-md-4">
                            <label for="example-text-input" class="form-control-label">Delivery Status</label>
                            <select class="form-control" v-model="customer.deliverystatus">
                                <option value="0">Pending</option>
                                <option value="1">Half Delivery</option>
                                <option value="2">Completed</option>
                            </select>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Checkout</h6>
                </div>
                <div class="container-fluid">
                    <div class="table-responsive p-0">
                        <table class="table align-items-center mb-0">
                            <thead>
                                <tr>
                                    <th class="text-uppercase text-xs font-weight-bolder">
                                    Product
                                    </th>
                                    <th class="text-uppercase text-xs font-weight-bolder">
                                    Content
                                    </th>
                                    <th class="text-uppercase text-xs font-weight-bolder">
                                    Price (RM)
                                    </th>
                                    <th class="text-uppercase text-xs font-weight-bolder">
                                    Sub Total(RM)
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in selectProducts" :key="index">
                                    <td>
                                        <div class="d-flex px-2 py-1">
                                            <div class="d-flex flex-column justify-content-center">
                                            <h5 class="mb-0 ">{{ item.name }}</h5>
                                            <h5 class=" text-secondary mb-0">{{ item.type }}</h5>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="max-width: 30%; width: 30%; white-space: normal; word-wrap: break-word;">
                                        <h4 class=" font-weight-bold" >
                                        {{ item.content }}
                                        </h4>
                                    </td>
                                    <td>
                                        <span class="font-weight-bold" >
                                        <h5 class="font-weight-bold mb-0">RM {{ item.price }}</h5>
                                        <h5 class="font-weight-bold mb-0">Qty: {{ item.quantity }}</h5>
                                        </span>
                                    </td>
                                    <td>
                                        <h4 class=" font-weight-bold" >
                                        RM {{ item.subtotal }}
                                        </h4>
                                    </td>
                                    <td>
                                        <button class="btn btn-warning" @click="RemovedCheckout(index)" ><font-awesome-icon icon="fa-solid fa-trash text-dark text-sm opacity-10" /></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col-md-8">
                            <h5 style="text-align: right">Total: </h5>
                        </div>
                        <div class="col-md-4">
                            <h5 style="text-align: right"><b class="text-xl">RM {{ customer.totalprice }}</b></h5>          
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-8">
                            <h5 style="text-align: right">Duit Turun Pokok: </h5>
                        </div>
                        <div class="col-md-4">
                            <h5 style="text-align: right"><b class="text-xl">RM {{ customer.dtp }}</b></h5>          
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-8">
                            <h5 style="text-align: right">Transport: </h5>
                        </div>
                        <div class="col-md-4">
                            <h5 style="text-align: right"><b class="text-xl">RM {{ customer.transport }}</b></h5>          
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col-md-8">
                            <h4 style="text-align: right">Grand Total: </h4>
                        </div>
                        <div class="col-md-4">
                            <h4 style="text-align: right"><b class="text-xl">RM {{ calTotalCost }}</b></h4>          
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12" style="padding-top:10px">
                            <button class="btn btn-success" @click="addOrder" style="float: right" id="btn_add">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <CustomerListModal @customerModel="selectedCustomer" >
    </CustomerListModal>
</div>
</template>


<script>
import axios from 'axios';
import { Modal } from 'bootstrap';

export default {
  name:'orderCreate',
  component:{
    CustomerListModal,
  },
  data(){
    return {
        myModal:'',
        componentKey: 0,
        productList:[],
        customer:{
            invoiceno:'',
            companyprofile:1,
            name:'',
            contact:'',
            address:'',
            company:'',
            billname:'',
            ic:'',
            totalprice:0,
            dtp:0,
            transport:0,
            grandtotal:0,
            orderstatus:0,
            saveCustomer:false,
            paymentdate: new Date().toISOString().slice(0,10),
            issuedate: new Date().toISOString().slice(0,10),
            orderlist:[],
        },
        // othercost:{
        //     dtp:0,
        //     transport:0
        // },
        product: {
            productsid:'',
            content:'',
            price:0,
            quantity:0,
            subtotal:0,
            name:'',
            size:''
        },
        selectProducts:[]
    }
  },
  computed: { 
    groupedProduct() { 
        const groups = {};

        this.productList.forEach(item => {
        const groupKey = `${item.category} / ${item.type}`;
        if (!groups[groupKey]) {
            groups[groupKey] = [];
        }
        groups[groupKey].push(item);
        });
        return groups;
    },
    calTotalCost(){
        this.customer.grandtotal = this.customer.totalprice + this.customer.dtp + this.customer.transport;
        return this.customer.grandtotal;
    } 
  },
  mounted(){
    this.listProduct();
    
    this.myModal = new Modal(document.getElementById('CustomerListModal'));
  },
  methods: {
    showPopupCustomerLisModal(){
        this.myModal.show();
    },
    selectedCustomer(mCustomer){
        this.customer.name = mCustomer.name;
        this.customer.ic = mCustomer.ic;
        this.customer.company = mCustomer.company;
        this.customer.address = mCustomer.address;
        this.customer.contact = mCustomer.contact;
    },
    RemovedCheckout(index){
        this.selectProducts.splice(index, 1);
    },
    addCheckOut(){
        if(this.product.quantity <= 0){
            alert("Quantity can't 0.");
            return;
        }else if(this.product.price <= 0){
            alert("Price can't 0.");
            return;
        }else if(this.product.productsid == "" || this.product.productsid <= 0){
            alert("Product Item is null! Please refresh the page.");
            return;
        }else if(this.product.content == ""){
            alert("Content can't be null.");
            return;
        }
        const found = this.productList.find(obj => Object.values(obj)[0] === this.product.productsid);
        this.product.subtotal = this.product.quantity*this.product.price;
        this.product.name = found.name;
        this.customer.totalprice = this.customer.totalprice + this.product.subtotal;

        this.selectProducts.push(this.product);
        this.product = {
            content: '',
            name: '',
            productsid: 1,
            quantity: 0,
            price: 0,
            subtotal: 0
        };
    },
    addOrder(){
        this.customer.orderlist = this.selectProducts;
        this.customer.billname = this.customer.name;
        // this.order.customer = this.customer;
        // this.order.orderDetails = this.selectProducts;
        // this.order.customer.total = this.totalPrices;
        // this.order.customer.tax = this.totalTax;
        // this.order.customer.price = (this.totalPrices - this.totalTax).toFixed(2);
        // this.order.ischeckDO = this.ischeckDO;
        // if(this.ischeckDO == true){
        //     this.order.delivery = this.customer;
        // }
        axios.post('order/addOrder',this.customer)
            .then(res => {
                alert(res.data.message);
                // this.uploadImage();
                // this.customer = null;
                this.customer.name = '';
                this.customer.contact = '';
                this.customer.address = '';
                this.customer.ic = '';
                this.customer.company = '';
                this.customer.orderstatus = 0;
                // this.customer.deliverystatus = 0;
                this.customer.price = 0;
                this.customer.tax = 0;
                this.customer.total = 0;
                this.customer.companyprofile = 1;
                this.selectProducts = null;
                this.customer.orderlist = null;
                this.customer.saveCustomer = false;
                this.customer.totalprice = 0;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        let error_message = error.response.data.message;
                        let messages = [];
                        // console.log(error_message);

                        for (let field in error_message) {
                            // console.log(field);
                            messages.push(error_message[field][0]); // get the first message for each field
                        }
                        // console.log(error_message);
                        alert(messages.join("\n")); // show all messages line by line
                    }else if(error.response.status == 409){
                        alert(error.response.data.message);
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    },
    listProduct(){
        axios.get('order/listAllProduct')
            .then(res => {
                // console.log(res.data.productslist);
                this.productList = res.data.productList;
                
                this.product.productsid = 1;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert(error.response.status);
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    }
  },
}
</script>